import { useAgentsAccessQuery } from './access.queries';

interface AgentsAccessState {
  hasAccess: boolean;
  loading: boolean;
}

// STD-015 thin wrapper — public contract unchanged. Server state lives in
// access.queries.ts. On error the query stays in isError state and data is
// undefined, which maps to hasAccess:false (silent probe behaviour preserved).
export function useAgentsAccess(): AgentsAccessState {
  const query = useAgentsAccessQuery();
  return {
    hasAccess: query.data ?? false,
    loading: query.isLoading,
  };
}
